// extracted by mini-css-extract-plugin
var _1 = "#101B21";
var _2 = "#709FFF";
var _3 = "#EDEEF0";
var _4 = "#51545A";
var _5 = "#E1E3E6";
var _6 = "#1F69FF";
var _7 = "#133F99";
var _8 = "#FFECE9";
var _9 = "https://g0.evitecdn.com/";
var _a = "#101B21";
var _b = "#FF9548";
var _c = "#C75300";
var _d = "#B9BCBF";
var _e = "#92959B";
var _f = "#E2ECFF";
var _10 = "#66DB86";
var _11 = "#20883C";
var _12 = "#28A842";
var _13 = "min-width: 80rem";
var _14 = "#3B5998";
var _15 = "#FF6348";
var _16 = "#FFECE9";
var _17 = "#FFECE9";
var _18 = "#D62000";
var _19 = "#709FFF";
var _1a = "#E2ECFF";
var _1b = "#E2ECFF";
var _1c = "#2424E5";
var _1d = "#FF9548";
var _1e = "#E092FF";
var _1f = "#B9BCBF";
var _20 = "#66DB86";
var _21 = "#E3FBE4";
var _22 = "#E3FBE4";
var _23 = "#20883C";
var _24 = "#FF9548";
var _25 = "#FFF5ED";
var _26 = "#FFF5ED";
var _27 = "#C75300";
var _28 = "#66DB86";
var _29 = "#F5F5F7";
var _2a = "#B9BCBF";
var _2b = "#B9BCBF";
var _2c = "#FFFFFF";
var _2d = "#FFFFFF";
var _2e = "#b31412";
var _2f = "calc(80rem - 0.1rem)";
var _30 = "min-width: 48rem";
var _31 = "calc(61.876rem - 0.1rem)";
var _32 = "min-width: 61.875rem";
var _33 = "#EBEAFD";
var _34 = "#F5F3F2";
var _35 = "#5352EB";
var _36 = "#5352EB";
var _37 = "#5352EB";
var _38 = "calc(48rem - 0.1rem)";
var _39 = "min-width: 31.25rem";
var _3a = "rgba(106, 110, 113, 0.2)";
var _3b = "#FF6348";
var _3c = "#D62000";
var _3d = "#E3FBE4";
var _3e = "rgba(227, 251, 228, 0.5)";
var _3f = "#6A6E71";
var _40 = "#92959B";
var _41 = "#6A6E71";
var _42 = "#FFFFFF";
var _43 = "#C10097";
var _44 = "#E092FF";
var _45 = "#C10097";
var _46 = "#FF9548";
var _47 = "#E092FF";
var _48 = "#66DB86";
var _49 = "#2E3136";
var _4a = "#E1E3E6";
var _4b = "calc(31.25rem - 0.1rem)";
var _4c = "min-width: 23.375rem";
var _4d = "clamp(2.5rem, 11vw, 5rem)";
var _4e = "clamp(1.5rem, 5vw, 3rem)";
var _4f = "clamp(1rem, 3vw, 1.5rem)";
var _50 = "6.5rem";
var _51 = "5rem";
var _52 = "#5352EB";
var _53 = "#2424E5";
var _54 = "#CA6E2E";
var _55 = "#E2ECFF";
var _56 = "#101B21";
var _57 = "#1DA1F2";
var _58 = "#FFF5ED";
var _59 = "#F4E2D5";
var _5a = "#FFFFFF";
export { _1 as "appleColor", _2 as "aquamarine", _3 as "ash", _4 as "asphalt", _5 as "borderColor", _6 as "brandPrimary", _7 as "brandPrimaryHover", _8 as "bubbleGum", _9 as "cdnPath", _a as "charcoal", _b as "citrine", _c as "citrineWebText", _d as "cloud", _e as "coin", _f as "cottonCandy", _10 as "emerald", _11 as "emeraldWebText", _12 as "eviteGreen", _13 as "extraLargeAndUpQuery", _14 as "facebookColor", _15 as "feedbackError", _16 as "feedbackErrorBg", _17 as "feedbackErrorSubtle", _18 as "feedbackErrorText", _19 as "feedbackInformation", _1a as "feedbackInformationBg", _1b as "feedbackInformationSuble", _1c as "feedbackInformationText", _1d as "feedbackMaybe", _1e as "feedbackNo", _1f as "feedbackNoReply", _20 as "feedbackSuccess", _21 as "feedbackSuccessBg", _22 as "feedbackSuccessSubtle", _23 as "feedbackSuccessText", _24 as "feedbackWarning", _25 as "feedbackWarningBg", _26 as "feedbackWarningSubtle", _27 as "feedbackWarningText", _28 as "feedbackYes", _29 as "fog", _2a as "formBorder", _2b as "formBorderDisabled", _2c as "formInputBg", _2d as "ghost", _2e as "googleColor", _2f as "largeAndUp", _30 as "largeAndUpQuery", _31 as "largishAndUp", _32 as "largishAndUpQuery", _33 as "lavender", _34 as "linen", _35 as "link", _36 as "linkColor", _37 as "linkHoverColor", _38 as "mediumAndUp", _39 as "mediumAndUpQuery", _3a as "menuHover", _3b as "mexicanOpal", _3c as "mexicanOpalWebText", _3d as "mintChip", _3e as "mintChipLight", _3f as "pebble", _40 as "placeholder", _41 as "popoverColor", _42 as "popoverTextColor", _43 as "premiumColor", _44 as "rose", _45 as "roseWebText", _46 as "rsvpMaybe", _47 as "rsvpNo", _48 as "rsvpYes", _49 as "shadow", _4a as "silver", _4b as "smallAndUp", _4c as "smallAndUpQuery", _4d as "spacingLg", _4e as "spacingMd", _4f as "spacingSm", _50 as "susHeaderDesktopScrollSpacing", _51 as "susHeaderMwScrollSpacing", _52 as "tanzanite", _53 as "tanzaniteWebText", _54 as "tigersEye", _55 as "tooltipColor", _56 as "tooltipTextColor", _57 as "twitterColor", _58 as "vanilla", _59 as "waffle", _5a as "white" }
